import { SignupPageLayout } from '@shared/components/page-layout';
import { useBrowserTitle } from '@shared/hooks/useBrowserTitle';
import * as React from 'react';

import { StepsContainer } from './components/steps-container';
import { StepIndicator } from './components/steps-indicator';

const SignupPage = () => {
    useBrowserTitle('Magicline Sign-up');

    return (
        <SignupPageLayout>
            <StepIndicator />
            <StepsContainer />
        </SignupPageLayout>
    );
};

export default SignupPage;
